var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-hello"},[_c('div',{staticClass:"header-hello-c"},[_c('div',[_c('p',[_vm._v("欢迎来到信用中国（甘肃）"),_c('span',[_vm._v("｜")])]),_c('p',[_vm._v("黄河之滨·诚信之城")])]),_c('div',[_c('p',[_vm._v("咨询投诉"),_c('span',[_vm._v("｜")])]),_c('p',[_vm._v("无障碍阅读"),_c('span',[_vm._v("｜")])]),_c('p',[_vm._v("适老版")])])])])
}]

export { render, staticRenderFns }